import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { AxiosError } from 'axios';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { PostRecentServiceParams, RecentService } from '../constants/types';

type PostRecentServiceOptions = UseMutationOptions<
  RecentService[],
  AxiosError,
  PostRecentServiceParams
>;

/**
 * 현재 사용자가 최근 사용 서비스를 업데이트하는 훅입니다.
 * @description
 * - react-query로 mutate를 제공합니다.
 */
const usePostRecentService = (options?: PostRecentServiceOptions) => {
  const client = useQueryClient();
  const { postRecentService } = useMetaApiInstance();

  const mutation = async (param: PostRecentServiceParams) => {
    const response = await postRecentService(param);
    return response;
  };

  return useMutation({
    mutationKey: [HOST_QUERY_KEY.UPDATE_RECENT_SERVICE],
    mutationFn: mutation,
    onSuccess: res => {
      client.setQueryData<RecentService[]>([HOST_QUERY_KEY.GET_RECENT_SERVICE], res);
    },
    ...options,
  });
};

export default usePostRecentService;
